var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#343A43"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7223 8C12.6872 8 7 13.7291 7 20.8169C7 26.4825 10.644 31.2783 15.6992 32.9757C16.3312 33.1033 16.5627 32.6999 16.5627 32.3606C16.5627 32.0634 16.5419 31.045 16.5419 29.9838C13.0028 30.7478 12.2659 28.4559 12.2659 28.4559C11.6971 26.9705 10.8544 26.5887 10.8544 26.5887C9.69608 25.8036 10.9388 25.8036 10.9388 25.8036C12.2237 25.8885 12.8979 27.1192 12.8979 27.1192C14.0351 29.0713 15.8677 28.5197 16.6049 28.1801C16.7101 27.3525 17.0474 26.7796 17.4054 26.4614C14.5828 26.1642 11.613 25.0609 11.613 20.1377C11.613 18.7372 12.1182 17.5914 12.9187 16.7002C12.7924 16.382 12.35 15.0661 13.0453 13.3049C13.0453 13.3049 14.1195 12.9653 16.5416 14.6205C17.5786 14.34 18.6481 14.1973 19.7223 14.1961C20.7966 14.1961 21.8916 14.3448 22.9028 14.6205C25.3252 12.9653 26.3994 13.3049 26.3994 13.3049C27.0947 15.0661 26.652 16.382 26.5257 16.7002C27.3473 17.5914 27.8317 18.7372 27.8317 20.1377C27.8317 25.0609 24.8619 26.1429 22.0182 26.4614C22.4817 26.8645 22.8817 27.6283 22.8817 28.8379C22.8817 30.5567 22.8609 31.9361 22.8609 32.3603C22.8609 32.6999 23.0926 33.1033 23.7244 32.9759C28.7796 31.278 32.4236 26.4825 32.4236 20.8169C32.4444 13.7291 26.7364 8 19.7223 8Z",
    fill: "#DEDEDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.fc74c229efdb84ce69638d23d7cd9ca8.svg";
export { ForwardRef as ReactComponent };